module.exports = __webpack_public_path__ + "img/Member icon-17.9b68dc74.png";